import { render } from "./ShuttleService.vue?vue&type=template&id=069043cc&scoped=true"
import script from "./ShuttleService.vue?vue&type=script&lang=js"
export * from "./ShuttleService.vue?vue&type=script&lang=js"

import "./ShuttleService.vue?vue&type=style&index=0&id=069043cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069043cc"]])

export default __exports__